import { downloadTransactions } from './downloadTransactions'

import urls from './urls.json'

async function downloadUserTransactions(onSuccessEvent, onErrorEvent) {
  const url = urls.downloadTransactions
  downloadTransactions(onSuccessEvent, onErrorEvent, url)
}

export { downloadUserTransactions }
